if (!customElements.get('bt-vendor-cards')) {
  class BtVendorCards extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.scrollRaf = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-bt-vc-track]');
      if (!this.track) return;

      this.prevBtn = this.querySelector('[data-bt-vc-prev]');
      this.nextBtn = this.querySelector('[data-bt-vc-next]');
      this.mobileLayout = this.dataset.mobileLayout || 'stack';

      this.setupExpandToggles();
      this.setupArrows();

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateArrows();

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          this.setupExpandToggles();
          this.updateArrows();
        });
        this.resizeObserver.observe(this.track);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    }

    setupExpandToggles() {
      const wraps = this.querySelectorAll('[data-bt-vc-desc-wrap]');
      wraps.forEach((wrap) => {
        const desc = wrap.querySelector('[data-bt-vc-desc]');
        const btn = wrap.querySelector('[data-bt-vc-more]');
        if (!desc || !btn) return;

        const isOverflowing = desc.scrollHeight > desc.clientHeight + 1;
        const isExpanded = desc.classList.contains('is-expanded');

        if (isOverflowing || isExpanded) {
          btn.hidden = false;
        } else {
          btn.hidden = true;
        }

        if (btn.dataset.btVcBound) return;
        btn.dataset.btVcBound = '1';

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const expanded = desc.classList.toggle('is-expanded');
          btn.textContent = expanded ? (btn.dataset.lessText || 'Daha Az') : (btn.dataset.moreText || 'Daha Fazla');
        });
      });
    }

    setupArrows() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByPage(1));
      }
    }

    onScroll() {
      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = requestAnimationFrame(() => this.updateArrows());
    }

    isMobileStacked() {
      return this.mobileLayout === 'stack' && window.matchMedia('(max-width: 749px)').matches;
    }

    scrollByPage(direction) {
      if (this.isMobileStacked()) return;
      const card = this.track.querySelector('.bt-vc__card');
      if (!card) return;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const cardWidth = card.getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.round(this.track.clientWidth / cardWidth));
      this.track.scrollBy({ left: cardWidth * visible * direction, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevBtn && !this.nextBtn) return;
      if (this.isMobileStacked()) {
        if (this.prevBtn) this.prevBtn.setAttribute('disabled', '');
        if (this.nextBtn) this.nextBtn.setAttribute('disabled', '');
        return;
      }
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      if (this.prevBtn) {
        atStart ? this.prevBtn.setAttribute('disabled', '') : this.prevBtn.removeAttribute('disabled');
      }
      if (this.nextBtn) {
        atEnd ? this.nextBtn.setAttribute('disabled', '') : this.nextBtn.removeAttribute('disabled');
      }
    }
  }

  customElements.define('bt-vendor-cards', BtVendorCards);
}
